<template>
    <div class="join-case">
        <nav-head :bg="false"></nav-head>
        <div class="ban-bg">
            <img src="~assets/images/product/txt-jiam.png">
        </div>
        <div class="case">
            <div class="item">
                <img class="title" src="~assets/images/product/suc1.png">
                <div class="item-txt">
                    客户A团队拥有网销基因,该客户分小组运作,在我们平台拥有多个代理商帐号,
                    仅以其中一个小组的3至6月份为例, 2019年4个月的时间销售额达
                    <span>327万元</span>,总利润达<span>160万元</span>,利润率将近<span>100%</span>
                </div>
                <div class="item-info">
                    <div>
                        <p>日累计统计(2019-03-01至2019-06-30)</p>
                        <p>期间总销售额：<span>3274775.9元</span></p>
                        <p>期间总销售成本: 1666824.5元</p>
                        <p>期间总销售利润: <span>1604774.35元</span></p>
                        <p>期间总成交笔数: 104791次</p>
                    </div>
                    <div class="info-f">
                       <div class="f-top">
                           <div class="short-rate">利润率</div><span>销售成本</span>
                       </div>
                        <div class="circle"><div class="rate">96<span>%</span></div></div>
<!--                        <el-progress type="circle" :percentage="50" :stroke-width="10" :width="80"></el-progress>-->
                        <div class="xslr">销售利润</div>
                    </div>
                </div>
                <table class="tb1">
                    <thead>
                    <tr>
                        <td >系统类型</td>
                        <td>销售总额</td>
                        <td>销售成本</td>
                        <td>销售利润</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>万方数据2.0——本科版</td>
                        <td>526475</td>
                        <td>210661.5</td>
                        <td>315413.5</td>
                    </tr>
                    <tr>
                        <td>万方数据2.0——硕士版</td>
                        <td>143500</td>
                        <td>41147</td>
                        <td>102203</td>
                    </tr>
                    <tr>
                        <td>硕博VIP\TMLC2</td>
                        <td>59755</td>
                        <td>36380</td>
                        <td>23375</td>
                    </tr>
                    <tr>
                        <td>本科PMLC</td>
                        <td>55958</td>
                        <td>34845</td>
                        <td>20083</td>
                    </tr>
                    <tr>
                        <td>大分解</td>
                        <td>3011</td>
                        <td>825</td>
                        <td>2141</td>
                    </tr>
                    <tr>
                        <td>期刊</td>
                        <td>25478</td>
                        <td>9047</td>
                        <td>16151</td>
                    </tr>
                    <tr>
                        <td>CHECKPASS</td>
                        <td>48411.6</td>
                        <td>2420.8</td>
                        <td>45932.8</td>
                    </tr>
                    <tr>
                        <td>ZAO JIANCE</td>
                        <td>3382</td>
                        <td>1696.6</td>
                        <td>1685.4</td>
                    </tr>
                    <tr>
                        <td>PAPERPASS</td>
                        <td>148949.6</td>
                        <td>64656.8</td>
                        <td>84292.8</td>
                    </tr>
                    <tr>
                        <td>维普本科版</td>
                        <td>2168538.5</td>
                        <td>1233064.9</td>
                        <td>934816.68</td>
                    </tr>
                    <tr>
                        <td>维普硕博版</td>
                        <td>23271.5</td>
                        <td>13144</td>
                        <td>10127.5</td>
                    </tr>
                    <tr>
                        <td>维普职称版</td>
                        <td>9700</td>
                        <td>5500</td>
                        <td>4200</td>
                    </tr>
                    <tr>
                        <td>PAPERYY</td>
                        <td>27943.2</td>
                        <td>4271.4</td>
                        <td>23545.77</td>
                    </tr>
                    <tr>
                        <td>PAPERRIGHT-VIP</td>
                        <td>19360.5</td>
                        <td>5357.5</td>
                        <td>13981.9</td>
                    </tr>
                    <tr>
                        <td>TURNITIN-国际版</td>
                        <td>2966</td>
                        <td>782</td>
                        <td>2108</td>
                    </tr>
                    <tr>
                        <td>TURNITIN-UK版</td>
                        <td>580</td>
                        <td>237</td>
                        <td>319</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="item">
                <img class="title" src="~assets/images/product/suc-2.png">
                <div class="item-txt">
                    客户B拥有渠道分销经验, 2018年加入检测行业,在我们的技术扶持下,第一
                    年营业额为196万元，第二年营业额为<span>790万元</span>
                </div>
                <div class="item-info">
                    <div>
                        <p>日累计统计( 2019-03-01至2019-06-30 )</p>
                        <p>期间总销售额: <span>4907813.4元</span></p>
                        <p>期间总销售成本: 2830936.81元</p>
                        <p>期间总销售利润: <span>1911857.59元</span></p>
                        <p>期间总成交笔数: 862185次</p>
                    </div>
                    <div class="info-f">
                        <img src="~assets/images/product/up.png">
                    </div>
                </div>
                <table>
                    <thead>
                    <tr>
                        <td>系统类型</td>
                        <td>销售总额</td>
                        <td>销售成本</td>
                        <td>销售利润</td>
                    </tr>
                    </thead>
                    <tbody class="tbody2">
                    <tr>
                        <td>万方数据2.0——本科版</td>
                        <td>45798</td>
                        <td>21418.5</td>
                        <td>24379.5</td>
                    </tr>
                    <tr>
                        <td>硕博VIP\TMLC2</td>
                        <td>570184</td>
                        <td>364255</td>
                        <td>182295</td>
                    </tr>
                    <tr>
                        <td>本科PMLC</td>
                        <td>2029648</td>
                        <td>1364860</td>
                        <td>588648</td>
                    </tr>
                    <tr>
                        <td>大分解</td>
                        <td>368644</td>
                        <td>150539</td>
                        <td>192315</td>
                    </tr>
                    <tr>
                        <td>分解</td>
                        <td>671670</td>
                        <td>238982</td>
                        <td>393272</td>
                    </tr>
                    <tr>
                        <td>CHECKPASS</td>
                        <td>277332</td>
                        <td>18328.71</td>
                        <td>259003.29</td>
                    </tr>
                    <tr>
                        <td>PAPERPASS</td>
                        <td>513212.4</td>
                        <td>370653.4</td>
                        <td>142559</td>
                    </tr>
                    <tr>
                        <td>维普本科版</td>
                        <td>431325</td>
                        <td>301900.2</td>
                        <td>129385.8</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="item">
                <img class="title" src="~assets/images/product/suc-3.png">
                <div class="item-txt">
                    客户C为在校大学生,学校每年都有毕业论文检测需求。他了解到学校使用何种检测系统时，
                    尝试性的用1000元作为项目启动资金,利用业余时间在学校论坛、
                    各种班级群传播检测网址,仅半个学期，为自己赚取了人生第一桶金<span>5.4万元</span>
                </div>
                <div class="item-info">
                    <div>
                        <p>日累计统计( 2019-03-01至2019-06-30 )</p>
                        <p>期间总销售额: <span>214929元</span></p>
                        <p>期间总销售成本: 155960.5元</p>
                        <p>期间总销售利润: <span>54265.8元</span></p>
                        <p>期间总成交笔数: 3032次</p>
                    </div>
                    <div class="info-f">
                        <div class="long">人生第一桶金</div>
                        <div class="money">
                            <span>5.4</span>万元
                        </div>
                    </div>
                </div>
                <table class="tb3">
                    <thead>
                    <tr>
                        <td>系统类型</td>
                        <td>销售总额</td>
                        <td>销售成本</td>
                        <td>销售利润</td>
                    </tr>
                    </thead>
                    <tbody class="tbody3">
                    <tr>
                        <td>硕博VIP\TMLC2</td>
                        <td>123934</td>
                        <td>92985</td>
                        <td>27720.64</td>
                    </tr>
                    <tr>
                        <td>本科PMLC</td>
                        <td>39855</td>
                        <td>28420</td>
                        <td>10899.9</td>
                    </tr>
                    <tr>
                        <td>大分解</td>
                        <td>3960</td>
                        <td>3737</td>
                        <td>3048</td>
                    </tr>
                    <tr>
                        <td>分解</td>
                        <td>36774</td>
                        <td>25667.5</td>
                        <td>10470.26</td>
                    </tr>
                    <tr>
                        <td>期刊</td>
                        <td>7406</td>
                        <td>5151</td>
                        <td>2127</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <back-top></back-top>
        <footer-version></footer-version>
    </div>
</template>

<script>
    import {NavHead,FooterVersion,BackTop} from "../components";
    import {linkRefresh} from "../common/mixin";

    export default {
        name: "JoinCase",
        components: {
            NavHead,
            BackTop,
            FooterVersion
        },
        mixins:[linkRefresh]
    }
</script>

<style scoped lang="less">
    .ban-bg {
        background-image: url("~assets/images/product/ban-jiam.jpg");
        img {
            height: 87px;
        }
    }
    .case {
        padding: 40px 0;
        .item {
            .title {
                height: 112px;
            }
            .item-txt {
                padding: 20px 0;
                border-top: 1px dashed #e8e8e8;
                border-bottom: 1px dashed #e8e8e8;
                line-height: 30px;
            }
            font-size: 20px;
            color: #333333;
            padding: 28px 30px;
            border-bottom: 28px solid #ecf7ff;
            &:last-child{
                border-bottom: none;
            }
            span {
                color: #126eac;
                font-weight: bold;
            }
            .item-info {
                display: flex;
                align-items: center;
                border-bottom: 1px dashed #e8e8e8;
                margin-bottom: 20px;
                p {
                    line-height: 30px;
                }
                &:first-child {
                    line-height: 26px;
                }
                .info-f {
                    font-size: 20px;
                    font-weight: bold;
                    text-align: center;
                    flex: 1;
                    position: relative;
                    padding:10px 0 10px 30px;
                    margin: 20px 0  20px 30px;
                    border-left: 1px dashed #e8e8e8;
                    img {
                        height: 156px;
                    }

                    .long {
                        background: url("~assets/images/product/long.png") no-repeat center/100% 100%;
                        height: 40px;
                        width: 144px;
                        color: #fff;
                        font-size: 20px;
                        margin-left: 15px;
                        text-align: center;
                        padding-top: 3px;
                    }
                    .money {
                        font-size: 30px;
                        color: #1b76b2;
                        font-weight: bold;
                        span {
                            font-size: 60px;
                            padding: 0 10px;
                        };
                    }
                    .f-top {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        span {
                            color: #dadada;
                        }
                    }
                    .circle {
                        width: 140px;
                        height: 140px;
                        border-radius: 50%;
                        border: 20px solid #126eac;
                        border-right-color: #d7d7d7;
                        border-top-color: #d7d7d7;
                        transform: rotate(45deg);
                        box-sizing: border-box;
                        display: inline-block;
                        position: relative;
                        .rate {
                            position: absolute;
                            color: #126eac;
                            top: 50%;
                            left: 50%;
                            font-size: 30px;
                            transform: rotate(-45deg) translate(0,-100%);
                            span {
                                font-size: 16px;
                            }
                        }
                    }
                    .xslr {
                        position: absolute;
                        color: #126eac;
                        left: 20px;
                        bottom: 10px;
                    }
                }
                .short-rate {
                    width: 85px;
                    height: 41px;
                    background: url("~assets/images/product/short.png") no-repeat center/100% 100%;
                    color: #fff;
                    padding-top: 5px;
                }
            }
                table {
                    border-spacing: 5px;
                    text-align: center;
                    td {
                        width: 148px;
                        height: 60px;
                        font-size: 20px;
                    }
                    tbody > tr > td {
                        background: #efefef;
                        color: #494949;
                    }
                    tbody > tr > td:first-child {
                    }
                    thead  td {
                        background: #898989;
                        color: #fff;
                        line-height: 30px;
                        font-size: 24px;
                        font-weight: bold;
                    }

                    td:last-child {
                        background: #1b76b2;
                        color: #fff;
                        width: 188px;
                    }

                    td:first-child {
                        width: 192px;
                    }
                    &.tb3 {
                        border-spacing: 5px 11px;
                        tbody td {
                            height: 88px;
                        }
                    }



                }

        }
    }
</style>